export const INTEGRATION_STATUSES = {
  private: {
    display: 'Private',
    lifecycle: 'build',
    name: 'private',
    published: false,
  },
  pending: {
    display: 'Pending',
    lifecycle: 'review',
    name: 'pending',
    published: false,
  },
  beta: {
    display: 'Public',
    lifecycle: 'beta',
    name: 'beta',
    published: true,
  },
  public: {
    display: 'Public',
    lifecycle: 'partnered',
    name: 'public',
    published: true,
  },
} as const;
